import { GRAVITY_WEBSITE_HANDOFF_STORAGE_KEY, GRAVITY_WEBSITE_HANDOFF_TTL_MS } from './gravityWebsiteHandoffConstants.js';
import isGravityWebsiteHandoffId from './isGravityWebsiteHandoffId.js';

const readGravityWebsiteHandoff = (now = Date.now()) => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const storage = window.sessionStorage;
    if (!storage) {
      return null;
    }

    const handoff = JSON.parse(storage.getItem(GRAVITY_WEBSITE_HANDOFF_STORAGE_KEY) || 'null');
    const isValid = isGravityWebsiteHandoffId(handoff?.handoffId) && Number.isFinite(handoff?.savedAt) && typeof handoff?.ready === 'boolean';

    if (!isValid || handoff.savedAt <= now - GRAVITY_WEBSITE_HANDOFF_TTL_MS) {
      try {
        storage.removeItem(GRAVITY_WEBSITE_HANDOFF_STORAGE_KEY);
      } catch {
        // Handoff cleanup must never block authentication.
      }
      return null;
    }

    return handoff;
  } catch {
    try {
      window.sessionStorage?.removeItem(GRAVITY_WEBSITE_HANDOFF_STORAGE_KEY);
    } catch {
      // Handoff cleanup must never block authentication.
    }
    return null;
  }
};

export default readGravityWebsiteHandoff;
